import { FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import classnames from 'classnames';

import dibsCss from 'dibs-css';
import styles from './PdpSharedDelimiter.scss';

export const PdpSharedDelimiter: FC = () => {
    return (
        <div
            className={classnames(
                styles.wrapper,
                dibsCss.flex,
                dibsCss.flexRow,
                dibsCss.justifyCenter,
                dibsCss.itemsCenter,
                dibsCss.sassyFontBodySmall,
                dibsCss.gapXSmall
            )}
        >
            <FormattedMessage id="PdpSharedDelimiter.or" defaultMessage="or" />
        </div>
    );
};
